export function runRateCopy(fiscal) {
  if (!fiscal || fiscal.regimen !== 'monotributo') return null;
  if (fiscal.yaSuperoTope) return 'Ya superaste el tope de la categoría. Orientativo.';
  if (!fiscal.mesEstimadoTope) return null;
  if (fiscal.mesesHastaTope != null && fiscal.mesesHastaTope < 1) {
    return 'A este ritmo llegás al tope este mes. Orientativo.';
  }
  return `A este ritmo llegás al tope en ${fiscal.mesEstimadoTope}. Orientativo.`;
}
